var exports = {
  "a": "DesktopDownloadNagbar.module__platformIcons___dmZGaz",
  "t": "DesktopDownloadNagbar.module__platformIcon___dmZGaz",
};

module.exports = exports;
